module.exports = new __parcel__URL__("frog.4c69f05a.svg").toString();